import React from "react";
import { useNavigate } from "react-router-dom";
import AdminUserApproval from "./AdminUserApproval";
import AdminFeedbackPanel from "./AdminFeedbackPanel";
import AdminPlanEntitlements from "./AdminPlanEntitlements";
import AdminSubscriptions from "./AdminSubscriptions";
import AdminMonitoringDashboard from "./AdminMonitoringDashboard";
import AdminLoginHistory from "./AdminLoginHistory";
import { buildScopedPath, getStoredWorkspace } from "./workspace/workspaceScope";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    const workspace = getStoredWorkspace();
    navigate(buildScopedPath("/app", workspace, "dashboard"));
  };

  return (
    <div className="admin-page">
      <div className="admin-container">
        <div className="admin-dashboard-actions">
          <button
            className="admin-back-home-btn"
            type="button"
            onClick={handleBackToHome}
            aria-label="Back to home"
          >
            <span className="admin-back-home-btn__icon" aria-hidden="true">&times;</span>
            <span>Back to Home</span>
          </button>
        </div>

        <div className="admin-dashboard-header">
          <span className="admin-dashboard-eyebrow">SignalFly Control Center</span>
          <h1>Admin Dashboard</h1>
          <p>Manage users, subscriptions, operational health, database capacity, and diagnostics.</p>
        </div>

        <AdminMonitoringDashboard />
        <AdminLoginHistory />
        <AdminUserApproval />
        <AdminSubscriptions />
        <AdminPlanEntitlements />
        <AdminFeedbackPanel />
      </div>
    </div>
  );
};

export default AdminDashboard;
